import React from 'react';
import { Field } from 'formik';

const SelectDonationType = ({ index, heading, label1, label2, extraUlClass }) => (
  <fieldset className="form-step hidden">
    <div className="form-step__header form-step__header--step1">
      <div className="form-step-header__number">{index}</div>
      <div className="form-step-header__title">{heading}</div>
    </div>
    <ul className={`form-fields form-fields--options ${extraUlClass}`}>
      <li key={1} className="form-field form-field-option">
        <Field type="radio" id="frequency-one-off" name="donationType" value="oneOff" />
        <label htmlFor="frequency-one-off">{label1}</label>
      </li>
      <li key={2} className="form-field form-field-option">
        <Field type="radio" id="frequency-regular" name="donationType" value="monthly" />
        <label htmlFor="frequency-regular">{label2}</label>
      </li>
    </ul>
  </fieldset>
);

export default SelectDonationType;
